export default [
  {
    path: 'applications',
    name: 'resource-queue-applications',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Applications/List.vue'
      ),
  },
  {
    path: 'applications/:applicationId',
    name: 'resource-queue-application-details',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Applications/Details.vue'
      ),
    props: true,
  },
  {
    path: 'reject',
    name: 'resource-reject-applications',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/RejectApplications/List.vue'
      ),
  },
  {
    path: 'reject-applications/:applicationId',
    name: 'resource-reject-application-details',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/RejectApplications/Details.vue'
      ),
    props: true,
  },
  {
    path: 'queue',
    name: 'resource-queue-queue',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Queue/List.vue'
      ),
  },
  {
    path: 'queue/:recordId',
    name: 'resource-queue-queue-details',
    component: () =>
      import(
        /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Queue/Details.vue'
      ),
    props: true,
  },
  {
    path: 'catalogs',
    component: () =>
      import(
        /* webpackChunkName: "RouterViewComponent" */ 'RootDir/shared_components/RouterViewComponent.vue'
      ),
    children: [
      {
        path: 'territories',
        name: 'resource-queue-territories',
        component: () =>
          import(
            /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Catalogs/Territories/List.vue'
          ),
      },
      {
        path: 'resources',
        name: 'resource-queue-resources',
        component: () =>
          import(
            /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Catalogs/Resources/List.vue'
          ),
      },
      {
        path: 'resource-periods',
        name: 'resource-queue-resource-periods',
        component: () =>
          import(
            /* webpackChunkName: "ResourceQueue" */ 'RootDir/modules/LimitingResourceQueue/Catalogs/ResourcePeriods/List.vue'
          ),
      },
    ],
  },
];
